











import { Component, Vue } from 'vue-property-decorator';
import { db } from '@/lib/ProductDatabase';
import AppUpdater from '@/components/AppUpdater.vue';
import MainDisplay from '@/components/MainDisplay.vue';
import Splash from '@/components/Splash.vue';
import ServiceWorkerManager from '@/lib/util/ServiceWorkerManager';
import UpdateTasks from '@/lib/UpdateTasks';
import { IS_LOCALHOST_8080 } from '@/lib/common/IsLocalhost';

const PRESENT_MOCK_UPDATE_DATA: boolean = false;
const MINIMUM_SPLASH_LOGO_MILLISECONDS = 650;
const workerManager = ServiceWorkerManager.instance();

@Component({
  components: {
    AppUpdater,
    MainDisplay,
    Splash,
  },
})
export default class Home extends Vue {

  // reactive properties
  nowShowing: ('main'|'splash'|'updater'|null) = null;
  updateTasks: UpdateTasks = {
    updates: [],
    deletes: [],
  };
  mockUpdateTasks: UpdateTasks = PRESENT_MOCK_UPDATE_DATA ? {
    updates: ['/path/to/non-existant.mp4', '/path/to/non-existant2.mp4', '/path/to/non-existant3.mp4'],
    deletes: ['/path/to/another/non-existant.mp4'],
  } : {
    updates: [],
    deletes: [],
  };

  // non-reactive properties
  private startedAtMilliseconds: number = 0;

  // lifecycle
  created() {
    this.startedAtMilliseconds = new Date().getTime();
  }
  mounted() {
    console.log("workerManager=", workerManager);
    if ( ! workerManager.isInitialized ) {
      this.nowShowing = 'splash';
      workerManager.whenReady()
      .then( async () => {
        console.log("workerManager=", workerManager);
        if ( workerManager.activeWorker ) {
          try {
            const tasks = await this.getUpdateTasks(workerManager.activeWorker);
            if ( (tasks.updates.length + tasks.deletes.length) > 0 ) {
              console.log('a cache update is needed');
              this.updateTasks = tasks;
              this.changeToScreenFollowingSplash('updater');
            }
            else {
              console.log('no cache update needed -- just launch main app');
              this.changeToScreenFollowingSplash('main');
            }
          }
          catch (error) {
            console.log("error on getUpdateTasks(): " + error);
            console.log("  `--> punting and just running the main app");
            this.changeToScreenFollowingSplash('main');
          }
        }
        else {
          console.log("there is no active service worker -- just launch main app");
          this.changeToScreenFollowingSplash('main');
        }
      })
      .catch((err) => {
        console.log(err);
        this.changeToScreenFollowingSplash('main');
      });
    }
    else {
      this.nowShowing = 'main';
    }
  }

  // computed
  get whitelabelPath(): string {
    return db.getWhitelabelPath();
  }
  get isShowSplash(): boolean {
    return 'splash' === this.nowShowing;
  }
  get isShowUpdater(): boolean {
    return 'updater' === this.nowShowing;
  }
  get isShowMainDisplay(): boolean {
    return 'main' === this.nowShowing;
  }

  // methods
  onStartKiosk() {
    this.nowShowing = 'main';
  }

  changeToScreenFollowingSplash(screen: ('main'|'updater')) {
    const now = new Date().getTime();
    const delay = Math.max(0, (MINIMUM_SPLASH_LOGO_MILLISECONDS + this.startedAtMilliseconds - now));
    setTimeout(() => {
      console.log("splash remaining was " + delay + "ms");
      this.nowShowing = screen;
    }, delay);
  }

  private getUpdateTasks(controller: ServiceWorker): Promise<UpdateTasks> {
    return IS_LOCALHOST_8080 ? this.getMockUpdateTasks() : this.getRealUpdateTasks(controller);
  }

  private getMockUpdateTasks(): Promise<UpdateTasks> {
    return new Promise<UpdateTasks>((resolve, reject) => {
      resolve(this.mockUpdateTasks);
    });
  }

  private getRealUpdateTasks(controller: ServiceWorker): Promise<UpdateTasks> {
    console.log('ask service worker if the cache needs updated');
    return new Promise<UpdateTasks>((resolve, reject) => {
      const channel = new MessageChannel();
      channel.port1.onmessage = (event) => {
        if ( event.data.error ) {
          reject(event.data.error);
        }
        else {
          resolve(event.data as UpdateTasks);
        }
      };
      console.log('  `--> send getCacheUpdateFileList message');
      controller.postMessage({
        name: 'getCacheUpdateFileList',
        list: db.getAllVideoFiles(),
        subpath: db.getWhitelabelPath(),
      }, [channel.port2]);
    });
  }

}

